{
  "concepts": {
    "infrastructure": {
      "label": "Infraestructura como servicio",
      "description": "Servicios y costos de infraestructura"
    },
    "licenses": {
      "label": "Licencias / Software como servicio",
      "description": "Licencias de software o uso"
    },
    "service": {
      "label": "Servicios profesionales",
      "description": "Servicios profesionales u operativos"
    },
    "support": {
      "label": "Servicios de soporte",
      "description": "Soporte y mantenimiento"
    }
  },
  "header": {
    "title": "PangeX",
    "item": {
      "home": "Home",
      "web": "AlsoThere",
      "faq": "FAQ",
      "contact": "Contacto"
    }
  },
  "screens": {
    "explore": {
      "title": "Explorar",
      "subtitle": "Esta app incluye código de ejemplo para ayudarte a empezar.",
      "sections": {
        "routing": "Ruteo basado en archivos",
        "platform": "Soporte Android, iOS y web",
        "images": "Imágenes",
        "theme": "Modo claro y oscuro",
        "animations": "Animaciones"
      }
    },
    "home": {
      "title": "Inicio",
      "welcomeMessage": "¡Bienvenido a la aplicación!"
    },
    "benchmarking": {
      "title": "Benchmarking Global",
      "subtitle": "Prueba un modelo de expansión en múltiples mercados para encontrar el mejor resultado.",
      "description": "Estas entradas serán comunes a todos los escenarios y servirán como base para su análisis comparativo.",
      "empty": {
        "title": "Sin Resultados",
        "description": "Completa el formulario para ver los resultados"
      },
      "addScenario": "Agregar Escenario",
      "scenario": "Escenario"
    },
    "faq": {
      "title": "Preguntas Frecuentes",
      "questions": {
        "q1": {
          "question": "¿Qué es AlsoThere? ",
          "answer": "AlsoThere es la <strong>mejor plataforma de infraestructura transaccional</strong> y la solución <strong>más rentable</strong> para la expansión global de empresas B2B, SaaS y de servicios profesionales en general. Funciona como una \"Subsidiaria on-Demand\", donde tu empresa vende sus servicios, hace la entrega del servicio y mantiene la relación comercial con el cliente final, mientras AlsoThere se encarga de cerrar el ciclo completo de una transacción internacional B2B, firmando contratos, emitiendo facturas locales, realizando la cobranza en moneda local y garantizando el cumplimiento con las regulaciones fiscales en cualquiera de los 43 países donde nos encontramos; sin necesidad de establecer oficinas físicas ni entidades legales, convirtiendo una expansión de alto riesgo (CAPEX) en un gasto operativo predecible (OPEX)."
        },
        "q2": {
          "question": "¿En qué consiste el modelo de \"Subsidiaria on-Demand\"?",
          "answer": "Una subsidiaria on-demand utiliza la infraestructura corporativa, financiera y legal de eSource Capital Group. Permite a tu empresa hacer negocios en un mercado extranjero sin establecer una presencia física o entidad legal permanente. A diferencia de una subsidiaria tradicional, que requiere una inversión significativa de tiempo, costo y esfuerzo administrativo para establecerse y mantenerse; nuestro servicio te permite enviar propuestas locales, firmar contratos locales, facturar localmente, facilitar la cobranza en moneda local y mantener el control de las relaciones con tus clientes."
        },
        "q3": {
          "question": "¿Cómo AlsoThere y su modelo de Subsidiaria on-Demand ayuda a mi empresa?",
          "answer": "<ul><li><strong>De CAPEX a OPEX (Hasta 10X más rentable):</strong> Transforma la inversión inicial de alto riesgo (CAPEX) que requiere una filial tradicional, que suele tomar de 6 a 12 meses, en un gasto operativo ágil y predecible (OPEX).</li> <li><strong>Velocidad de Lanzamiento (Speed to Lead):</strong> Al estar operativo en días, puedes acelerar tus ingresos y capitalizar al instante a tus clientes pioneros (early adopters) en múltiples mercados simultáneamente; mientras obtienes data real del comportamiento de cada uno de los mercados, ayudándote a tomar mejores decisiones.</li><li> <strong>Control Total del Cliente:</strong> A diferencia del modelo de revendedores tradicionales que secuestran tu relación comercial, nosotros actuamos solo como tu infraestructura transaccional para que tú mantengas el 100% del control de tus clientes y márgenes.</li><li> <strong>Cumplimiento Normativo Completo:</strong> Actuamos como tu agente autorizado para garantizar el cumplimiento de las leyes locales, facilitando la consolidación financiera y el cobro en hasta 14 divisas diferentes.</li></ul> <strong>Nuestro Respaldo:</strong> Impulsados por los más de 20 años de experiencia en regulaciones transfronterizas de eSource Capital Group, hemos procesado de forma segura más de US$250 millones en facturaciones a nombre de clientes empresariales a nivel mundial."
        },
        "q4": {
          "question": "¿Cómo funciona la calculadora/simulador de expansión internacional y qué escenarios puedo comparar?",
          "answer": "La Calculadora/Simulador PangeX utiliza datos reales según las regulaciones fiscales entre los países seleccionados y los valores de los escenarios que quieres simular. Te provee tanto un comparativo de los distintos modelos de negocios bajo los cuales podrás expandirte a un país (Model Comparison); o un comparativo de cómo variaría un mismo modelo de expansión en distintos países (Global BenchMark)"
        },
        "q5": {
          "question": "¿Qué escenarios de expansión puedo comparar?",
          "answer": "La herramienta compara automáticamente <strong>cuatro modelos principales de expansión internacional</strong>:<ol><li><strong>Facturación Internacional Directa</strong> (desde alguno de tus países en donde tienes entidad legal).</li><li>Uso de un <strong>Partner Local.</strong></li><li>Apertura de una <strong>Subsidiaria Propia.</strong></li><li>El modelo de <strong>AlsoThere</strong>.</li></ol>"
        },
        "q6": {
          "question": "¿Por qué a mi cliente le conviene una factura local en lugar de una internacional?",
          "answer": "Emitir una factura local es la mejor estrategia para eliminar barreras de compra. A tu cliente le conviene por estas razones principales:<ul><li><strong>Deducibilidad y Ahorro Directo:</strong> Las legislaciones fiscales locales (como el SAT en México, AFIP en Argentina o DIAN en Colombia) exigen un comprobante local válido para que un gasto sea deducible. Esto permite a tu clientedefinir su base gravable del Impuesto Sobre la Renta (ISR) y acreditar el IVA local, traduciéndose en una recuperación financiera.</li><li><strong>Eliminación de Sobrecostos (Competitividad):</strong> Al emitir una factura internacional, la regulación de tu país de origen podría exigirte incluir tu propio IVA. Dado que tu cliente en el extranjero no puede deducir ni acreditar un impuesto de otro país, esto incrementa directamente el costo final del servicio para él, haciéndote perder competitividad frente a los proveedores locales.</li><li><strong>Mitigación de Riesgos y Penalizaciones:</strong> A diferencia de una factura internacional, que carece de validez fiscal en el país destino, una factura local garantiza el cumplimiento total de las normas de forma y fondo. Esto protege al cliente frente a posibles auditorías, multas o sanciones derivadas de una incorrecta justificación de gastos.</li><li><strong>Procesos de pago simplificados:</strong> Elimina las complicaciones financieras al permitir que el cliente pague en su propia moneda local (evitando fluctuaciones cambiarias) y a través de sus sistemas tradicionales.</li><li><strong>Desbloqueo de cuentas corporativas (Enterprise-ready):</strong> Muchas grandes corporaciones tienen políticas estrictas que les prohíben legalmente hacer pagos a entidades extranjeras si no reciben una factura local. Facturar localmente te da acceso inmediato a este nivel de clientes.</li><li><strong>Credibilidad y confianza en el mercado:</strong> Operar bajo las leyes y normativas locales transmite transparencia, estabilidad y un compromiso a largo plazo que una empresa extranjera remota no puede igualar</li></ul>"
        },
        "q7": {
          "question": "¿Para qué tipo de empresas está diseñada esta solución?",
          "answer": "AlsoThere está optimizada para empresas de <strong>servicios basados en conocimientos de cualquier tamaño</strong>. Es la solución ideal para:<ul><li>Proveedores de Software como Servicio (SaaS) e ISVs.</li><li>Agencias digitales y de marketing.</li><li>Firmas de consultoría y exportadores de servicios profesionales.</li><li>Empresas con clientes internacionales o enfocadas en ventas transfronterizas (crossborder).</li></ul> Por otra parte AlsoThere no presta sus servicios para ventas a entidades gubernamentales, o a empresas que desean vender productos físicos que requieren logística de importación y exportación, ni tampoco se involucra con la contratación de personal o pago de nómina."
        },
        "q8": {
          "question": "¿AlsoThere ayuda en la contratación de personal o manejar nóminas?",
          "answer": "<p>AlsoThere no ofrece servicios directos de recursos humanos, nóminas o modelo de empleador registrado (EoR). Este modelo se especializa exclusivamente en ser una <strong>capa transaccional y comercial </strong>que maneja contratos, facturación, cobros y cumplimiento fiscal (impuestos).</p><p>Dado que el objetivo es expandirse internacionalmente minimizando los riesgos financieros y pasando de un modelo de CAPEX a OPEX, aquí tienes un marco de trabajo de 4 pasos para escalar el talento al prestar servicios en nuevos países:</p><ol><li><strong>Comienza de forma ligera (Lean):</strong> Gestiona las ventas iniciales con tus recursos actuales o contrata talento adicional únicamente en los países donde ya tengas una entidad legal establecida.</li><li><strong>Soporte bajo demanda:</strong> Cuando alcances el nivel de necesitar gestión de cuentas a tiempo parcial o un centro de atención al cliente (help desk) de primer nivel en nuevos mercados, AlsoThere ofrece estos servicios directamente bajo el modelo de Subsidiary On-Demand.</li><li><strong>Contratación local:</strong> Una vez que alcances una masa crítica de negocio y requieras talento local dedicado, puedes contratarlos sin complicaciones a través de servicios globales de empleo como Remote, Globalization Partners o Adecco, entre otros.</li><li><strong>Expansión física estratégica:</strong> Finalmente, cuando logres un flujo de caja sólido, valides un crecimiento positivo y estés alineado con los objetivos estratégicos, podrás considerar con seguridad la apertura de una nueva entidad legal en ese país específico y establecer un equipo local.</li></ol>"
        },
        "q9": {
          "question": "¿Mantendré el control de mis clientes si uso AlsoThere?",
          "answer": "<strong>Sí, mantendrás el 100% del control de tus clientes.</strong> A diferencia de los revendedores tradicionales que secuestran la relación con el usuario final, AlsoThere actúa únicamente como tu infraestructura de apoyo (un 'Plug-In' operativo). Tú mantienes el control total sobre las ventas, la relación con el cliente, el ciclo comercial y la fijación de precios."
        },
        "q10": {
          "question": "¿Qué tan rápido puedo empezar a facturar en un nuevo país?",
          "answer": "<p>Con AlsoThere, tu empresa estará lista para operar, firmar contratos y emitir facturas locales legalmente en tan rápido como en <strong>48 horas</strong>; al cumplir con los procesos de alta de proveedor por parte de tu cliente final.</p>"
        },
        "q11": {
          "question": "¿Qué me permite simular la calculadora?",
          "answer": "<p>PangeX le permite proyectar la exportación de sus servicios a diversos mercados globales. La herramienta genera estimaciones de <strong>ingresos netos</strong> a través de dos enfoques estratégicos:</p><ul><li><strong>Comparativa de Modelos (Model Comparison):</strong> Evalúe el impacto financiero de diferentes esquemas de exportación dentro de un mismo país para identificar la ruta más rentable.</li><li><strong>Análisis Comparativo Global (Global Benchmark): </strong>Compare cómo se comporta un mismo modelo de expansión en distintos países, facilitando la priorización de mercados según su rentabilidad."
        },
        "q12": {
          "question": "¿Los resultados de la calculadora son exactos?",
          "answer": "<p>Los resultados de la calculadora deben considerarse como una proyección estimada, no resultados exactos. Los factores clave que determinan por qué los valores finales pueden variar:</p><p><strong>Factores de Variabilidad</strong></p><ul><li><strong>Fluctuaciones del Mercado:</strong> Los valores estimados pueden cambiar según las condiciones del mercado y otros factores externos que ocurran entre el momento del cálculo y la transacción real.</li><li><strong>Tipo de Cambio Dinámico: </strong>Aunque para la simulación de escenario se utiliza un tipo de cambio del día de la simulación, en la ejecución real se aplicará el tipo de cambio vigente al momento de cada transacción (tanto al cobrar al cliente como al pagar al proveedor).</li><li><strong>Fuente Oficial:</strong> Los tipos de cambio se rigen por las fuentes oficiales de los bancos centrales (o equivalentes) de los países involucrados.</li></ul><p><strong>Referencia de Divisas</strong></p><ul><li>Para mantener la coherencia en la simulación de diferentes escenarios, utilizamos el dólar estadounidense (USD) como moneda de referencia para el pago final. Sin embargo, es importante recordar que los pagos en el país de destino se realizarán en la moneda local.</li></ul>"
        },
        "q13": {
          "question": "¿Cuánto cuesta abrir una subsidiaria tradicional en comparación con AlsoThere?",
          "answer": "<p>AlsoThere es la <strong>mejor solución</strong> para tu expansión global, siendo una alternativa hasta <strong>10 veces más rentable</strong> que una configuración tradicional. Mientras que el modelo clásico exige altos y riesgosos costos de capital (CAPEX), AlsoThere transforma tu entrada al mercado en un gasto operativo (OPEX) predecible y recurrente, <strong>eliminando por completo los costos de infraestructura.</strong></p><p>Para entender el impacto financiero, aquí tienes la comparación directa de ambos modelos:</p><ul><li><strong>Subsidiaria Tradicional: </strong> Tarda entre 5 a 10 meses en estar lista para operar. Requiere una inversión inicial de entre <strong>$7,500 y 38,000USD</strong>, exclusivamente para la configuración legal y contable. A esto se suman costos operativos mensuales mínimos que oscilan entre <strong> 3,500 y $11,000 USD </strong> por país, únicamente para la gestión administrativa y de facturación local, sin considerar los gastos asociados a la adquisición de clientes.</li><li><strong>La alternativa AlsoThere: No hay ningún costo inicial </strong>por acceder a nuestro servicio, plataforma y network global. Bajo el modelo de 'Subsidiaria On-Demand', <strong>solo pagas cuando hayas utilizado nuestros servicios.</strong> El cobro se realiza únicamente después de que recibimos el pago de tu cliente final y procesamos el pago al proveedor correspondiente. Este costo se estructura a través de un fee por factura, cuyo porcentaje dependerá específicamente del monto, la frecuencia y el monto total a facturar anualmente en cada país.<p>Como la principal plataforma del mercado para la internacionalización B2B, AlsoThere se adapta a las necesidades operativas de tu empresa para ayudarte a acelerar tu crecimiento. Buscamos ofrecerte siempre la opción más competitiva, de manera que con nosotros recibas el mejor Net Revenue (ingreso neto) y puedas empezar a vender en 48 horas sin asumir los riesgos financieros de la vieja escuela.</p></li></ul>"
        },
        "q14": {
          "question": "¿Qué riesgos mitiga el modelo de AlsoThere?",
          "answer": "Al ser la <strong>mejor solución estratégica</strong> para la expansión global, el modelo de 'Subsidiaria On-Demand' de AlsoThere te protege de manera integral contra los mayores riesgos de la internacionalización, incluyendo:<ul><li><strong>Riesgo financiero y el 'derecho a equivocarse de país': </strong>Al eliminar la necesidad de invertir en altos costos de infraestructura (CAPEX) y convertir tu entrada al mercado en un gasto operativo (OPEX) flexible, el modelo te otorga el valioso <strong>derecho a equivocarte de país.</strong> Evita que gastes capital prematuramente en un mercado equivocado, mitigando la riesgosa apuesta del 'todo o nada'. Si pruebas un mercado y la demanda no es la esperada, puedes simplemente iterar y pasar al siguiente territorio sin haber perdido meses de tiempo ni decenas de miles de dólares en abrir y cerrar entidades legales.</li><li><strong>Riesgos de cumplimiento legal y fiscal:</strong> Como tu <strong>principal infraestructura transaccional</strong>, AlsoThere asume y gestiona la complejidad regulatoria. Esto evita multas, disputas o penalizaciones por el desconocimiento de las leyes fiscales de otros países, garantizando un cumplimiento normativo total (Compliance-as-a-Service) para que operes con tranquilidad.</li><li><strong>Riesgos cambiarios:</strong> Reduce significativamente tu exposición a la volatilidad de las divisas extranjeras. La plataforma te permite facturar directamente en moneda local y gestionar consolidaciones de pagos en múltiples divisas (hasta 14 monedas) de manera centralizada y segura.</li><li><strong>Riesgo de oportunidad (Time-to-Market):</strong> Elimina el riesgo de perder a tus early adopters (clientes pioneros) por demoras burocráticas. Al estar operativo legal y comercialmente en 48 horas en lugar de esperar de 6 a 12 meses, capitalizas de inmediato la demanda existente y cierras contratos antes de que tu competencia pueda reaccionar.</li></ul>"
        },
        "q15": {
          "question": "¿Qué impuestos y costos considera la expansión (y qué necesito para recibir pagos)?",
          "answer": "<p>Para garantizar que cuentes con la <strong>mejor infraestructura transaccional</strong> en tu expansión global, el flujo para la recepción de pagos con AlsoThere está diseñado para ser ágil, seguro y 100% en cumplimiento normativo. Para comenzar a recibir tus pagos, el proceso paso a paso es el siguiente: firmas un <strong>Acuerdo Maestro</strong> (o Master Agreement) con nosotros, envías a tu cliente una cotización utilizando que ya incluye las condiciones del servicio, y el cliente local firma un acuerdo de servicio autorizandonos explícitamente a facturar y cobrar en tu nombre.</p><p>Una vez que la subsidiaria local de AlsoThere emite la factura y recauda exitosamente el dinero, te transfiere los fondos directamente a tu cuenta bancaria según el calendario de pagos acordado, deduciendo únicamente los siguientes conceptos:</p><ul><li><strong>Impuestos aplicables:</strong> Se contemplan los impuestos locales de la jurisdicción y el <strong>impuesto de retención (Withholding Tax o WHT)</strong>. Es fundamental destacar que <strong>este WHT es exactamente el mismo que se te aplica cuando facturas internacionalmente</strong> de forma directa.</li><li><strong>Costos y Comisiones operativas:</strong> Se deducen las comisiones y tarifas operativas previamente acordadas (el fee por transacción). Todo esto se enmarca bajo un <strong>gasto operativo (OPEX) predecible</strong>, garantizando que no incurras en gastos ocultos de mantenimiento y maximizando la rentabilidad de tu expansión.</li></ul><p>Al ser la <strong>mejor infraestructura transaccional</strong>, este esquema simplificado te permite operar de inmediato, delegando toda la complejidad financiera y regulatoria sin los detalles operativos abrumadores.</p>"
        }
      }
    }
  },
  "home": {
    "hero": {
      "title": "Encuentra el camino más rentable para tu expansión global",
      "subtitle": "Deja de adivinar tus costos internacionales. Usa PangeX para comparar: Facturación internacional, subsidiarias tradicionales, socios locales y el modelo de Subsidiaria on-Demand de AlsoThere utilizando las políticas actuales de Impuesto de Retención y costos operativos estimados. Encuentra la estrategia exacta que maximiza tu Ingreso Neto.",
      "cta": "Simular",
      "comparison": {
        "title": "Comparación de Modelos PangeX",
        "description": "Encuentra la infraestructura más rentable para tu mercado objetivo"
      },
      "benchmarking": {
        "title": "Benchmarking Global PangeX",
        "description": "Valida un modelo de negocio en varios países"
      }
    },
    "features": {
      "earnings": {
        "title": "Ingresos Internacionales Estimados",
        "description": "Deja de adivinar tus márgenes globales. PangeX utiliza regulaciones fiscales en tiempo real, tipos de cambio oficiales y datos de retención de impuestos para proyectar con precisión tus ingresos netos."
      },
      "enablement": {
        "title": "Facilitación para la expansión global",
        "description": "PangeX ayuda a las empresas de tecnología y servicios basados ​​en el conocimiento a encontrar su camino más rentable hacia 43 países de EE. UU., la UE y Latinoamérica."
      },
      "results": {
        "title": "Resultados Inmediatos",
        "description": "PangeX compara los principales modelos de expansión. Toma decisiones basadas en datos para mitigar los riesgos financieros y acelerar la generación de ingresos."
      }
    },
    "scenarios": {
      "header": "Escenarios del sistema",
      "loading": "Cargando datos...",
      "error": "Error al cargar datos",
      "notFound": "Par no encontrado en Firestore para {{customer}}_{{vendor}}.",
      "resultsTitle": "Resultados del Modelo de Comparación PangeX",
      "resultsBadge": "SIMULACIÓN COMPLETADA",
      "resultsSubtitle": "Basándonos en las regulaciones fiscales en tiempo real y los tipos de cambio dinámicos de los bancos centrales oficiales, hemos comparado tus ingresos netos proyectados con los principales modelos de expansión internacional.",
      "resultsDescription": "En lugar de ventajas y desventajas genéricas, te ofrecemos información financiera basada en datos para evaluar el coste de su entrada al mercado y el riesgo."
    },
    "reportForm": {
      "title": "Obtén tu Reporte detallado",
      "description": "Ingresa tu información para recibir un email con los resultados de la simulación.",
      "nameLabel": "Nombre Completo",
      "namePlaceholder": "Tu nombre",
      "emailLabel": "Correo Electrónico",
      "emailPlaceholder": "tu@email.com",
      "submitButton": "Obtener Reporte",
      "success": "¡Reporte enviado con éxito! Revisa tu correo.",
      "error": "Hubo un error al enviar el reporte. Por favor, intenta de nuevo."
    },
    "compare": {
      "cta": {
        "schedule": {
          "title": "Agendar una reunión",
          "description": "Habla con uno de nuestros expertos para profundizar en tu caso.",
          "button": "Agendar"
        },
        "scheduleAlsoThere": {
          "title": "Se ha encontrado un ingresos netos proyectados más favorable con AlsoThere",
          "description": "Agendar una reunión gratis para conocer mas.",
          "button": "Agendar"
        },
        "alsoThere": {
          "title": "Also There",
          "description": "Conoce más sobre cómo podemos ayudarte a escalar.",
          "button": "Mas info"
        }
      }
    }
  },
  "scenarios": {
    "types": {
      "localPartner": {
        "title": "Socio Local",
        "subtitle": "Venta a través de un socio local (margen aplicado)",
        "resume": {
          "risk": "Riesgo general",
          "competitiveness": "Competitividad general",
          "items": {
            "first": "Dependencia de terceros",
            "second": "Margen compartido",
            "third": "Conocimiento Local"
          }
        }
      },
      "internationalInvoicing": {
        "title": "Facturación Internacional",
        "subtitle": "Facturación internacional (sin entidad local)",
        "resume": {
          "risk": "Riesgo general",
          "competitiveness": "Competitividad general",
          "items": {
            "first": "Riesgo de establecimiento permanente",
            "second": "Sin soporte legal local",
            "third": "Costo inicial bajo"
          }
        }
      },
      "localSubsidiary": {
        "title": "Subsidiaria Local",
        "subtitle": "Operar a través de una subsidiaria local",
        "resume": {
          "risk": "Riesgo general",
          "competitiveness": "Competitividad general",
          "items": {
            "first": "Altos costos de setup",
            "second": "Burocracia administrativa",
            "third": "Control total"
          }
        }
      },
      "alsoThere": {
        "title": "AlsoThere",
        "subtitle": "Usa AlsoThere para gestionar pagos transfronterizos",
        "resume": {
          "risk": "Riesgo general",
          "competitiveness": "Competitividad general",
          "items": {
            "first": "Cumplimiento legal 100% garantizado",
            "second": "Sin entidad legal requerida",
            "third": "Gestion de RRHH y nomina incluida",
            "fourth": "Un solo fee mensual"
          }
        }
      }
    },
    "card": {
      "customerCountry": "País del Cliente",
      "vendorCountry": "País del Vendedor (Destino de Pago)",
      "concept": "Concepto",
      "invoicingAmount": "Monto de Facturación",
      "localInvoicingDetails": "Detalles de Facturación Local",
      "exchangeRate": "Tipo de Cambio",
      "invoiceAmountLocal": "Ventas mensuales estimadas",
      "localVat": "IVA Local ({{rate}})",
      "estimatedLocalInvoice": "Monto estimado de factura local al cliente final",
      "results": "Resultados",
      "operationalCosts": "Costos Operativos Adicionales Estimados del País (Impuestos no recuperables) ({{rate}})",
      "wht": "Impuesto de Retención Estimado del País ({{rate}})",
      "transactionCost": "Costo de transacción",
      "sharedMargin": "Margen Compartido con Socio Local ({{rate}})",
      "financialStructure": "Costo medio mensual de la estructura financiera",
      "indirectCosts": {
        "label": "Costo indirecto para el cliente",
        "value": "No deducible fiscalmente"
      },
      "estimatedPayment": "Ingresos Netos Proyectados",
      "estimatedPaymentUSD": "Ingresos Netos Proyectados en USD",
      "invoicing": "Facturación",
      "costs": "Costos",
      "netRevenueExclusions": "Exclusiones de Ingresos Netos",
      "localVatTooltip": "El IVA Local genera un crédito fiscal al cliente final, no incrementa el costo para el cliente, ni impacta su ingreso neto",
      "netRevenueExclusionsTooltip": "Son impuestos y cualquier otra retención requerida por la Ley aplicable.",
      "setupAndOperationalCosts": {
        "title": "Costos de Configuración y Operativos",
        "tooltip": "Agrupa la inversión inicial y los gastos recurrentes necesarios para operar legalmente en un nuevo mercado. El impacto financiero varía según el modelo de expansión.",
        "value": {
          "localPartner": "Implica costos variables por la búsqueda, negociación y gestión de la alianza comercial.",
          "internationalInvoicing": "Sin costos de configuración. Se factura directamente en USD desde el país de origen.",
          "localSubsidiary": "Es el modelo más costoso, ya que exige crear y mantener una infraestructura legal y operativa permanente en el país destino.",
          "alsoThere": ""
        },
        "items": {
          "setupCost": "Costo de configuración",
          "operationalCost": "Costo operativo mensual"
        }
      },
      "scability": {
        "title": "Escalabilidad",
        "tooltip": "Evalúa la capacidad de crecer ágilmente en nuevos mercados, proyectando confianza local y manteniendo el control de tu expansión.",
        "value": {
          "localPartner": "Requiere un socio local en cada país, para usar su infraestructura.",
          "internationalInvoicing": "Te perciben como extranjero y tiene complejidad fiscal/cambiaria para el cliente.",
          "localSubsidiary": "Tarda de 5 a 10 meses por país, el crecimiento es rígido y alto riesgo de capital.",
          "alsoThere": ""
        },
        "items": {
          "presence": "Presencia corporativa sólida desde el primer día",
          "scalability": "Escalabilidad internacional controlada"
        }
      },
      "timeToMarket": {
        "title": "Tiempo de salida al mercado",
        "tooltip": "Mide el tiempo que tardas en poder vender, firmar contratos y facturar legalmente en un nuevo país.",
        "value": {
          "localPartner": "3 a 7 meses de búsqueda y negociación del acuerdo.",
          "internationalInvoicing": "Inmediato, pero genera carga fiscal al cliente y suele ser rechazado por clientes corporativos.",
          "localSubsidiary": "5 a 11 meses de trámites legales y configuración contable.",
          "alsoThere": ""
        }
      },
      "transactionalAndPaymentCapabilities": {
        "title": "Capacidades transaccionales y de pago",
        "tooltip": "Mide la capacidad de eliminar barreras financieras, adaptándose a las necesidades fiscales y operativas del cliente.",
        "value": {
          "localPartner": "",
          "internationalInvoicing": "Incrementa los costos indirectos para el cliente, ya que la factura no es deducible de impuestos en su país. También limita el pago en moneda local.",
          "localSubsidiary": "",
          "alsoThere": ""
        },
        "items": {
          "localInvoicingBenefits": "Beneficio de facturación local para el cliente final",
          "localCurrencyPayments": "Pago del cliente final en moneda local",
          "consolidation": "Consolidación de pagos multi-país"
        }
      },
      "customerRelationship": {
        "title": "Gestión de relaciones con clientes",
        "tooltip": "Mide tu capacidad para formalizar negocios localmente sin sacrificar el control sobre tus cuentas.",
        "value": {
          "localPartner": "El intermediario controla la relación y baja tu margen.",
          "internationalInvoicing": "Usa leyes extranjeras.",
          "localSubsidiary": "",
          "alsoThere": ""
        },
        "items": {
          "localizedContacts": "Contratos localizados con clientes",
          "clientRelationship": "Mantener control total sobre la relación con los clientes"
        }
      },
      "businessAutonomy": {
        "title": "Autonomía del negocio e ingresos",
        "tooltip": "Mide tu capacidad para operar internacionalmente sin perder el control comercial ni ceder tus márgenes de beneficio.",
        "value": {
          "localPartner": "El intermediario recorta tu margen comercial y dependes de sus reglas y prioridades.",
          "internationalInvoicing": "",
          "localSubsidiary": "",
          "alsoThere": ""
        },
        "items": {
          "operationalIndependence": "Independencia operativa",
          "retainControl": "Mantener el control sobre las ganancias"
        }
      },
      "compliance": {
        "title": "Cumplimiento de regulaciones fiscales locales",
        "tooltip": "Mide tu capacidad de operar cumpliendo estrictamente con las leyes de impuestos del país destino, protegiendo a ambas partes de multas o problemas legales.",
        "value": {
          "localPartner": "",
          "internationalInvoicing": "La facturación internacional a menudo genera cargas financieras y administrativas ocultas para los clientes, lo que los lleva a exigir facturas locales que cumplan con las normativas fiscales.",
          "localSubsidiary": "",
          "alsoThere": ""
        }
      }
    },
    "actions": {
      "manage": "Gestionar escenarios",
      "select": "Seleccionar escenarios"
    },
    "resultsBadge": {
      "risk": "Mide tu nivel de exposición financiera, comercial y legal al entrar a un nuevo país.",
      "competitiveness": "Mide tu capacidad de vender en el extranjero con la misma fuerza, facilidad y confianza que una empresa local."
    }
  },
  "onboarding": {
    "title": "Comparación del Modelo PangeX",
    "subtitle": "Encuentra el camino más rentable para tu expansión global. Deja de adivinar tus costos internacionales.",
    "description": "Te ayudamos a entender escenarios, costos y oportunidades antes de dar el próximo paso.",
    "sections": {
      "marketScope": "Alcance de Mercado",
      "financialParameters": "Parámetros Financieros",
      "businessIndustry": "Negocio e Industria",
      "selectScenarios": "Seleccionar escenarios"
    },
    "steps": {
      "pair": {
        "title": "Mercados de exportación",
        "subtitle": "Definí tu ruta de exportación"
      },
      "commercial": {
        "title": "Configuración comercial",
        "subtitle": "¿Cómo se estructura el acuerdo?"
      },
      "invoicing": {
        "title": "Facturación",
        "subtitle": "Detalles de monto y moneda"
      },
      "review": {
        "title": "Revisión",
        "subtitle": "Confirma y ejecuta el análisis"
      }
    },
    "actions": {
      "next": "Siguiente",
      "back": "Atrás",
      "clear": "Limpiar",
      "cancel": "Cancelar",
      "run": "Ejecutar análisis",
      "edit": "Editar",
      "continue": "Continuar a la simulación"
    },
    "fields": {
      "vendorCountryListTooltip": "Países con filiales operativas; los países donde tu empresa tiene entidades legales",
      "vendorCountryList": "Selecciona Mercados Establecidos",
      "vendorCountryTooltip": "País que recibirá los ingresos proyectados. El país de origen que emite la factura internacional al cliente",
      "vendorCountry": "Selecciona País de Reconocimiento de Ingresos",
      "customerCountryTooltip": "El nuevo país donde planeas vender. Actualmente sin filiales operativas (entidad legal)",
      "customerCountry": "Selecciona País de Expansión",
      "searchPlaceholder": "Selecciona un país de expansión",
      "invoicingConcept": "Selecciona la categoría de servicio a facturar",
      "invoicingConceptTooltip": "Tipo de servicio a facturar al cliente final en el nuevo mercado",
      "currencyQuestion": "¿Cuál es el presupuesto estimado y en qué moneda?",
      "localPartnerQuestion": "Habilitar escenario de socio local",
      "partnerMargin": "Selecciona el margen a asignar a un socio local",
      "partnerMarginPlaceholder": "ej. 45",
      "partnerMarginDescription": "Ingresá el porcentaje de comisión o margen que retiene tu socio local por la operación.",
      "invoicingAmount": "Ventas mensuales estimadas a clientes finales",
      "invoicingAmountDescription": "Importe proyectado a facturar a clientes finales",
      "invoicingAmountPlaceholder": "ej. 50.000",
      "selectScenarios": "Seleccionar canales de exportación",
      "selectScenariosTooltip": "Selecciona los canales de exportación que quieres comparar",
      "scenario": "Escenario de Expansión",
      "scenarioTooltip": "Facturación internacional (exportación directa sin presencia física), partner local (facturación a través de un aliado en el país para simplificar la carga operativa) o constituir una subsidiaria local (entidad propia para operar y facturar con control total en el mercado destino).",
      "errors": {
        "selectOrigin": "Seleccioná uno o mas paises",
        "selectDestination": "Seleccioná un pais",
        "validAmount": "Ingresá un monto válido",
        "validMargin": "Ingresá un margen válido",
        "selectAtLeastOneScenario": "Seleccioná al menos un escenario",
        "invoicingConcept": "Seleccioná un negocio o industria",
        "differentOriginDestination": "El origen y el destino deben ser diferentes",
        "partnerMarginRequired": "El margen del socio es requerido"
      }
    },
    "warnings": {
      "exchangeControl": "Este país no esta disponible y no puede ser utilizado para el análisis de escenarios o benchmarking"
    },
    "review": {
      "title": "Revisa tus datos",
      "pair": "Par",
      "concept": "Concepto",
      "pricing": "Precios",
      "localPartner": "Socio local",
      "amount": "Monto",
      "currency": "Moneda"
    },
    "summary": {
      "title": "Entradas del Modelo",
      "vendorCountryList": "Mercados Establecidos",
      "vendorDestination": "Reconocimiento de Ingresos",
      "customerOrigin": "País de Expansión",
      "invoicingAmount": "Ventas mensuales estimadas",
      "invoicingConcept": "Categoría de servicio a facturar",
      "localInvoicingDetails": "Detalles de Facturación Local",
      "localPartnerMargin": "Margen del Socio Local",
      "margin": "Margen"
    },
    "commonSectionHint": "Estas entradas son comunes a todos los escenarios y servirán como base para su análisis comparativo. En el siguiente paso, podrá crear distintos escenarios para compararlos entre sí."
  },
  "common": {
    "yes": "Sí",
    "no": "No",
    "search": "Buscar...",
    "select": "Seleccionar...",
    "noMatches": "Sin resultados",
    "selectAll": "Seleccionar todo",
    "loading": "Cargando...",
    "sending": "Enviando...",
    "cancel": "Cancelar",
    "save": "Guardar cambios",
    "step": "Paso",
    "of": "de",
    "user": "Usuario",
    "logoAlt": "Logo de PangeX",
    "iconAlt": "Icono de PangeX",
    "backgroundAlt": "Fondo decorativo abstracto",
    "underConstruction": {
      "title": "En Construcción",
      "description": "Estamos trabajando duro para traerte esta funcionalidad pronto. ¡Mantente al tanto!"
    },
    "levels": {
      "low": "Bajo",
      "medium": "Medio",
      "high": "Alto"
    },
    "edit":"Editar",
    "reset":"Reset"
  },
  "footer": {
    "tagline": "\"PangeX\" tiene origen en \"Pangea\", implica la reunificación de los territorios, la eliminación de fronteras y la consolidación de los mercados.",
    "privacy": "Privacidad",
    "terms": "Términos",
    "sitemap": "Mapa del sitio",
    "rights": "© {{year}} PangeX. Todos los derechos reservados.",
    "contact": "Información de contacto"
  },
  "cta": {
    "schedule": {
      "title": "Agendar un análisis de escenario gratuito",
      "description": "Habla con uno de nuestros expertos para profundizar en tu caso.",
      "button": "Agendar"
    },
    "contact": {
      "title": "Contactanos",
      "description": "Conoce más sobre cómo podemos ayudarte a escalar.",
      "comment": "Ayúdanos a hacer esta herramienta más útil, envíanos tus sugerencias.",
      "button": "Contactar"
    }
  },
  "countries": {
    "br": "Brasil",
    "ar": "Argentina",
    "bo": "Bolivia",
    "cl": "Chile",
    "co": "Colombia",
    "cr": "Costa Rica",
    "ec": "Ecuador",
    "sv": "El Salvador",
    "gt": "Guatemala",
    "hn": "Honduras",
    "mx": "México",
    "ni": "Nicaragua",
    "pa": "Panamá",
    "py": "Paraguay",
    "pe": "Perú",
    "do": "República Dominicana",
    "de": "Alemania",
    "at": "Austria",
    "be": "Bélgica",
    "bg": "Bulgaria",
    "cy": "Chipre",
    "hr": "Croacia",
    "dk": "Dinamarca",
    "sk": "Eslovaquia",
    "si": "Eslovenia",
    "es": "España",
    "ee": "Estonia",
    "fi": "Finlandia",
    "fr": "Francia",
    "gr": "Grecia",
    "hu": "Hungría",
    "ie": "Irlanda",
    "it": "Italia",
    "lv": "Letonia",
    "lt": "Lituania",
    "lu": "Luxemburgo",
    "mt": "Malta",
    "nl": "Países Bajos",
    "pl": "Polonia",
    "pt": "Portugal",
    "cz": "República Checa",
    "ro": "Rumanía",
    "se": "Suecia",
    "us": "Estados Unidos",
    "uy": "Uruguay",
    "ve": "Venezuela",
    "gb": "Reino Unido",
    "ca": "Canadá",
    "in": "India",
    "ch": "Suiza",
    "no": "Noruega",
    "sg": "Singapur"
  },
  "report": {
    "compare": {
      "title": "Sus escenarios de expansión internacional",
      "description": "Compare el impacto financiero de cada modelo",
      "table": {
        "headers": {
          "advantages": "Ventajas Competitivas",
          "internationalInvoicing": "Facturación Internacional",
          "localPartner": "Usar Socio Local",
          "localSubsidiary": "Establecer Subsidiaria Propia",
          "alsoThere": "AlsoThere"
        },
        "rows": {
          "row1": "Contratos localizados con clientes",
          "row2": "Facturación local",
          "row3": "Factura deducible de impuestos para el Cliente",
          "row4": "Cumplimiento con regulaciones fiscales locales",
          "row5": "El cliente paga en su moneda local",
          "row6": "Cumple con políticas de compras corporativas",
          "row7": "Escalabilidad controlada",
          "row8": "Consolidación de pagos multi-país",
          "row9": "Retener el control total sobre la relación con clientes",
          "row10": "Retain Control on Profits",
          "row11": "Presencia corporativa robusta desde el primer día",
          "row12": "Costo de configuración sin riesgos",
          "row13": "Activación inmediata"
        }
      }
    }
  }
}